import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './containers/App'
import { Auth0Provider } from '@auth0/auth0-react'
import { Amplify } from 'aws-amplify'
import config from './aws-exports'
import { mswEnabled } from './mocks/toggles'

Amplify.configure(config)

const container = document.getElementById('root')
const root = createRoot(container)

async function start() {
  if (typeof window !== 'undefined' && mswEnabled()) {
    const { worker } = await import('./mocks/browser')
    await worker.start({
      onUnhandledRequest: 'bypass', // No interceptar requests no mockeadas
      serviceWorker: { url: '/mockServiceWorker.js' }
    })
    console.log('MSW habilitado - Interceptando peticiones de Schedule y Checkout')
  }

  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        redirectUri={`${window.location.origin}/auth`}
        cacheLocation="localstorage"
      >
        <App />
      </Auth0Provider>
    </React.StrictMode>
  )
}

start()
